// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewVideo_container__6OOpC","body":"PreviewVideo_body__2h2d3","title":"PreviewVideo_title__2xOdT","video-container":"PreviewVideo_video-container__39lfo"};